import React, { Component } from "react";
import { Col, Form, Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  changePassword,
  userSecurityKeyV2,
  getOtpVerification
} from "../../actions/common.action";
import { PASSWORD_VALIDATE } from "../../validation";
import { withRouter } from "react-router-dom";
import { ERROR_MSG } from "../../constant";
import { get } from "lodash";
import { JSEncrypt } from "jsencrypt/lib";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PasswordChangeModal from "./passwordChangeModal";
import { LoaderPage } from "../../component/Loader";
import { getUserOtp } from "../../actions/userManagement.action";
import { successToastStyle, errorToastStyle } from "../../customToast";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmPassword: "",
      errors: {},
      displayModal: false,
      type: "password",
      otp: "",
      verified: "",
      passwordMatched: false,
      showPassword: false,
      showConfirmPassword: false,
      isLoading: false
    };
  }

  validateField = (fieldName, value) => {
    let { errors, newPassword, confirmPassword } = this.state;
    switch (fieldName) {
      case "newPassword":
        errors.newPasswordValid = PASSWORD_VALIDATE(value);
        break;
      case "confirmPassword":
        errors.confirmPasswordValid = PASSWORD_VALIDATE(value, newPassword);
        break;
      default:
        errors.newPasswordValid = PASSWORD_VALIDATE(newPassword);
        errors.confirmPasswordValid = PASSWORD_VALIDATE(
          confirmPassword,
          newPassword
        );
        break;
    }
    this.setState({
      errors: { ...errors }
    });
  };

  getSecurityKey = async () => {
    let { userSecurityKeyV2 } = this.props;
    const { oldPassword, newPassword, confirmPassword } = this.state;
    try {
      await userSecurityKeyV2();
      const { securityKeyData } = this.props;
      if (get(securityKeyData, "id")) {
        let userID = get(securityKeyData, "id");
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(get(securityKeyData, "key"));
        const encryptedOldPassword = encrypt.encrypt(oldPassword);
        const encryptedNewPassword = encrypt.encrypt(newPassword);
        const encryptedConfirmPassword = encrypt.encrypt(confirmPassword);
        this.setState({
          encryptedOldPassword,
          encryptedNewPassword,
          encryptedConfirmPassword,
          userID
        });
        this.handleChangePassword();
      } else {
        toast.error(
          <p className="toast-text-alignment">Please check your credentials</p>,
          errorToastStyle
        );
      }
    } catch (e) {
      console.log(`Error in Change Password ${e.message}`);
    }
  };

  handleChangePassword = async event => {
    const {
      encryptedOldPassword,
      encryptedNewPassword,
      encryptedConfirmPassword,
      userID
    } = this.state;
    this.validateField();
    let isValid = this.validateForm();

    if (isValid) {
      this.setState({
        isLoading: true
      });
      const response = await changePassword(undefined, {
        oldPassword: encryptedOldPassword,
        newPassword: encryptedNewPassword,
        confirmPassword: encryptedConfirmPassword,
        key: userID
      });
      if (response) {
        const { data, status } = response;
        if (status) {
          this.setState({
            displayModal: true
          });
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {get(data, "message", "NA")}
            </p>,
            successToastStyle
          );
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    }
  };

  restrictSpace = event => {
    let key = event ? event.which : window.event.keyCode;
    if (key === 32) {
      event.preventDefault();
    }
  };

  validateForm = () => {
    let { errors } = this.state;
    let { newPasswordValid, confirmPasswordValid } = errors;
    return (
      (newPasswordValid &&
        newPasswordValid.error &&
        confirmPasswordValid &&
        confirmPasswordValid.error) !== undefined &&
      !newPasswordValid.error &&
      !confirmPasswordValid.error
    );
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  };

  showPassword = e => {
    e.preventDefault();
    e.stopPropagation();
    const { showPassword, showConfirmPassword } = this.state;

    if (e.target.role === "newPassword") {
      this.setState({
        showPassword: !showPassword
      });
    } else {
      this.setState({
        showConfirmPassword: !showConfirmPassword
      });
    }
  };

  onsubmit = async () => {
    let { getChangePasswordOtp } = this.props;
    try {
      let otpResult = await getChangePasswordOtp();
      toast.success(
        <p className="toast-text-alignment">
          {get(otpResult, "message", "NA")}
        </p>,
        successToastStyle
      );
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{get("Error")}</p>,
        errorToastStyle
      );
    }
  };

  onChange = async (value, key) => {
    if (value.length === 6) {
      let resp = await getOtpVerification(undefined, {
        otp: value
      });

      this.setState({
        verified: resp.data.message
      });
    }
  };

  checkForMatched = confirmPassword => {
    let { newPassword } = this.state;
    this.setState({
      passwordMatched: confirmPassword && confirmPassword === newPassword
    });
  };

  render() {
    const {
      errors,
      newPassword,
      confirmPassword,
      type,
      otp,
      verified,
      passwordMatched,
      showConfirmPassword,
      showPassword,
      isLoading
    } = this.state;
    const { isOtpResponseFetch } = this.props;

    return (
      <>
        <LoaderPage loading={!isOtpResponseFetch.status === true} />
        <div className="user-form-container">
          <div className="change-password-form">
            <div className="form-heading">
              <h3 className="m-0">Change Password</h3>
            </div>
            <div className="otp-text">
              An OTP has been sent to your registered email ID
            </div>
            <div className="form-container">
              <Form>
                <Form.Group className="field-cin-number">
                  <div className="form-field">
                    <Form.Control
                      type="text"
                      placeholder="Enter OTP*"
                      className={`otp-field ${
                        verified !== "success" && verified !== ""
                          ? "is-invalid"
                          : "otp-field-input"
                      }`}
                      name="otp"
                      maxLength={6}
                      onChange={e => this.onChange(e.target.value, "")}
                    />
                    {verified === "" && (
                      <p className="resend-text">
                        Haven’t received the OTP? &nbsp;
                        <text
                          onClick={this.onsubmit}
                          className="on-hover"
                          style={{ cursor: "pointer" }}
                        >
                          Resend
                        </text>
                      </p>
                    )}
                    {verified !== "success" && verified !== "" && (
                      <p className="invalid-text">Invalid OTP</p>
                    )}
                    {verified === "success" && (
                      <p className="authenticate-text">OTP Authenticated</p>
                    )}
                  </div>
                </Form.Group>
                {verified === "success" && verified !== "" && (
                  <>
                    <div className="dotted-line" />
                    <div className="password-fields">
                      <Form.Group as={Col}>
                        <Form.Label>
                          Create new password
                          <span className="required">*</span>
                        </Form.Label>
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          name="newPassword"
                          placeholder="Create password"
                          className="otp-field"
                          onChange={this.handleChange}
                          onBlur={() => {
                            this.validateField("newPassword", newPassword);
                            this.checkForMatched(confirmPassword);
                          }}
                          onKeyPress={this.restrictSpace}
                          isInvalid={
                            errors.newPasswordValid &&
                            errors.newPasswordValid.error
                          }
                        />
                        <span
                          role="newPassword"
                          className={`eye_icon mt-2 ${
                            showPassword ? "" : "eye_hide"
                          }`}
                          onClick={this.showPassword}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.newPasswordValid &&
                          errors.newPasswordValid.error
                            ? errors.newPasswordValid.message
                            : null}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label>
                          Confirm password
                          <span className="required">*</span>
                        </Form.Label>
                        <Form.Control
                          type={showConfirmPassword ? "text" : "password"}
                          name="confirmPassword"
                          placeholder="Confirm password"
                          onChange={this.handleChange}
                          className="otp-field"
                          onBlur={() => {
                            this.validateField(
                              "confirmPassword",
                              confirmPassword
                            );
                            this.checkForMatched(confirmPassword);
                          }}
                          onKeyPress={this.restrictSpace}
                          isInvalid={
                            errors.confirmPasswordValid &&
                            errors.confirmPasswordValid.error
                          }
                        />
                        <span
                          role="confirmPassword"
                          className={`eye_icon mt-2 ${
                            showConfirmPassword ? "" : "eye_hide"
                          }`}
                          onClick={this.showPassword}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.confirmPasswordValid &&
                          errors.confirmPasswordValid.error
                            ? errors.confirmPasswordValid.message
                            : null}
                        </Form.Control.Feedback>
                        {passwordMatched ? (
                          <span className="password-matched">
                            Password Matched
                          </span>
                        ) : null}
                      </Form.Group>
                    </div>
                    <div className="reset-button">
                      <Button
                        variant="primary"
                        type="button"
                        className="btn-orange full-width"
                        onClick={this.getSecurityKey}
                      >
                        RESET PASSWORD
                      </Button>
                    </div>
                  </>
                )}
              </Form>
              <LoaderPage loading={isLoading && !this.state.displayModal} />
              <Modal
                show={this.state.displayModal}
                onHide={this.onToggleModal}
                className="successfully-modal"
              >
                <div>
                  <Modal.Body className="body-modal">
                    <PasswordChangeModal />
                  </Modal.Body>
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    securityKeyData: state.loginReducer.securityKeyData,
    isOtpResponseFetch: state.userManagementReducer.otpResponse
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      userSecurityKeyV2,
      getOtpVerification,
      getChangePasswordOtp: getUserOtp
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ChangePassword)
);
